import styled from "styled-components";

export const AssetFormModalStyle = styled.div`

`;
